import React, { FC } from 'react'
import { sum } from 'ramda'
import { useTranslation } from 'react-i18next'
import { useFetchWidget } from 'services/widget'
import { BarChart } from 'components/BarChart'
import { ColumnChart } from 'components/ColumnChart'
import { DonutChart } from 'components/DonutChart'
import { PyramidChart } from 'components/PyramidChart'
import { Widget as WidgetModel } from 'models/widget'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { Formula } from 'components/Formula'
import { Card } from 'components/Card'
import { Heading } from 'components/Heading'
import styles from './ReportWidgets.module.scss'

type ReportWidgetProps = {
  widget: WidgetModel
  projectId: string
  areaId: string
}

const AVAILABLE_WIDGETS = {
  BarChart,
  ColumnChart,
  DonutChart,
  PyramidChart,
  Formula,
}

export const ReportWidget: FC<ReportWidgetProps> = ({ widget, projectId, areaId }) => {
  const { t } = useTranslation()
  const { data } = useFetchWidget({
    widgetId: widget.id,
    projectId,
    areasIds: areaId,
  })
  const Component = AVAILABLE_WIDGETS[widget.type]

  return (
    <Card className={styles.widget}>
      <Stack space="medium">
        <div>
          <Heading size="widget" className={styles.title}>
            {widget.title}
          </Heading>
          <Text>
            <Text component="span" weight="strong" className={styles.totalTitle}>
              {t('widgets.total')}:
            </Text>{' '}
            {data?.values?.map((values: number[], index: number) => {
              return (
                <span key={index}>
                  <Text component="span" weight="strong" className={styles.totalNumber}>
                    {sum(values)}
                  </Text>
                  {data.values.length > 1 && index < data.values.length - 1 && (
                    <Text component="span"> {t('widgets.vs')} </Text>
                  )}
                </span>
              )
            })}
          </Text>
        </div>
        <div className={styles.chart}>
          {data && <Component data={data as any} showLongLabels />}
        </div>
      </Stack>
    </Card>
  )
}
